// todo: ストレージのファイル名にドメイン名を露出させているが、より適切な名称があれば変更したい
//  詳しくはPRの議論を参考: https://github.com/ubie-inc/sushiro/pull/156#discussion_r1814252417

import { AuthProvider } from '~/types/AuthProvider';
import { generateJsonTransformer, LocalStorage, SessionStorage } from '~/utils/storage/storage';
import { Sex, UbiePersonRelationship } from '../../../gen/graphql/graphql';

export const ubieAuthStorage = new LocalStorage<{
  authAccountId: string;
  accessToken: string;
}>({
  key: 'ubie-auth',
  transformer: generateJsonTransformer(),
});

export const oidcStateStorage = new LocalStorage<{
  state: string;
  redirectUri?: string;
  provider: AuthProvider;
}>({
  key: 'oidc-state',
  transformer: generateJsonTransformer(),
});

export const ubiePersonEditStorage = new SessionStorage<{
  id?: string;
  relationship?: UbiePersonRelationship;
  age?: number;
  sex?: Sex;
}>({
  key: 'ubie-person-edit',
  transformer: generateJsonTransformer(),
});

export const inquirySettingsStorage = new SessionStorage<{
  doneScreenKey?: string | null; // スマホ問診完了画面での案内方法
  toririnrinId?: string | null; // とりりんりん患者ID
  skipSignup?: boolean;
}>({
  key: 'inquiry-settings',
  transformer: generateJsonTransformer(),
});

export const selectedUbiePersonStorage = new SessionStorage<{
  id: string; // 選択したUbiePersonのID
}>({
  key: 'selected-ubie-person',
  transformer: generateJsonTransformer(),
});

export const sessionTrackingStorage = new SessionStorage<string | null>({
  key: 'session_tracking_uid',
  transformer: generateJsonTransformer(),
});
